import { render, staticRenderFns } from "./ProgressBar.vue?vue&type=template&id=24751664&scoped=true"
import script from "./ProgressBar.vue?vue&type=script&lang=js"
export * from "./ProgressBar.vue?vue&type=script&lang=js"
import style0 from "./ProgressBar.vue?vue&type=style&index=0&id=24751664&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24751664",
  null
  
)

export default component.exports